import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV = [
  { to: "/films", label: "Films" },
  { to: "/gallery", label: "Gallery" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-700 ${
        scrolled ? "bg-[#1A1514]/92 backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-16 py-5 md:py-7 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo-link"
          aria-label="Cineglimpse Stories — home"
          className="block transition-opacity duration-700 hover:opacity-85"
        >
          <div
            className="h-12 md:h-16 w-56 md:w-72 bg-no-repeat bg-center"
            style={{
              backgroundImage:
                "url('https://customer-assets.emergentagent.com/job_luxury-wedding-films-16/artifacts/lubzfoaa_2.png')",
              backgroundSize: "cover",
            }}
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-10" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[11px] tracking-[0.28em] uppercase transition-colors duration-500 editorial-link ${
                  isActive ? "text-ink-champagne" : "text-ink-ivory/80 hover:text-ink-ivory"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        {/* Mobile trigger */}
        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle navigation menu"
          onClick={() => setMobileOpen((s) => !s)}
          className="md:hidden flex flex-col gap-[5px] p-2 -mr-2"
        >
          <span className={`block h-px w-6 bg-ink-ivory transition-transform duration-500 ${mobileOpen ? "translate-y-[6px] rotate-45" : ""}`} />
          <span className={`block h-px w-6 bg-ink-ivory transition-opacity duration-500 ${mobileOpen ? "opacity-0" : "opacity-100"}`} />
          <span className={`block h-px w-6 bg-ink-ivory transition-transform duration-500 ${mobileOpen ? "-translate-y-[6px] -rotate-45" : ""}`} />
        </button>
      </div>

      {/* Mobile overlay */}
      <div
        className={`md:hidden fixed inset-0 luxe-backdrop transition-opacity duration-700 ${
          mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        data-testid="mobile-menu-overlay"
      >
        <nav className="h-full flex flex-col items-center justify-center gap-10" aria-label="Mobile">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
              className="font-display text-3xl tracking-tight text-ink-ivory editorial-link"
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
